export { StarRating } from './StarRating';